import React from "react";
import Header from "../../components/header/index";
import InnerHeader from "../../components/comment/innerHeader/innerHeader";
import VerificationContent from "./content/verificationContent";

import Footer from "../../components/footer";

const index = () => {
  return (
    <div className="main">
      <Header />
      <InnerHeader title="profile Verification " />
      <VerificationContent />
      <Footer />
    </div>
  );
};

export default index;
